import HousekeepingStatusBoardDispatcher from '../dispatcher/HousekeepingStatusBoardDispatcher';
import HousekeepingStatusBoardConstants from '../constants/HousekeepingStatusBoardConstants';

const HousekeepingStatusBoardActions = {
  init(opts) {
    HousekeepingStatusBoardDispatcher.dispatch({
      action: HousekeepingStatusBoardConstants.INIT,
      opts: opts
    });
  },

  gotoDate(date) {
    HousekeepingStatusBoardDispatcher.dispatch({
      action: HousekeepingStatusBoardConstants.GOTO_DATE,
      date: date
    });
  },

  setActiveTab(tab) {
    HousekeepingStatusBoardDispatcher.dispatch({
      action: HousekeepingStatusBoardConstants.SET_ACTIVE_TAB,
      tab: tab
    });
  },

  setLoading(loading) {
    HousekeepingStatusBoardDispatcher.dispatch({
      action: HousekeepingStatusBoardConstants.SET_LOADING,
      loading: loading
    });
  },

  updateBoardData(data) {
    HousekeepingStatusBoardDispatcher.dispatch({
      action: HousekeepingStatusBoardConstants.UPDATE_BOARD_DATA,
      data: data
    });
  },

  onExpandCollapseRoomType(roomType, collapsed) {
    HousekeepingStatusBoardDispatcher.dispatch({
      action: HousekeepingStatusBoardConstants.EXPAND_COLLAPSE_ROOM_TYPE,
      collapsed: collapsed,
      roomType: roomType,
    });
  }
};

export default HousekeepingStatusBoardActions;